export const FIND_EMPLOYEE_FAILURE = 'FIND_EMPLOYEE_FAILURE';

export const findEmployeeFailure = error => ({
    type: FIND_EMPLOYEE_FAILURE,
    payload: error,
    error: true,
});
